// extracted by mini-css-extract-plugin
export var specialOffer = "SpecialOffer-module--specialOffer--kz+yd";
export var inner = "SpecialOffer-module--inner--TboQ4";
export var close = "SpecialOffer-module--close--sRmfb";